export default function isString(val) {
  return typeof val === 'string';
};